import script from "./SliderElement.vue?vue&type=script&lang=js"
export * from "./SliderElement.vue?vue&type=script&lang=js"

import "./SliderElement.vue?vue&type=style&index=0&id=a4928bf0&lang=scss"

const __exports__ = script;

export default __exports__